import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";
import truncateString from "../../../../ui/utils/truncateString";

export default function useAlertsColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "title",
			Header: t("title", "Title"),
			collapsing: true,
			disableSortBy: true,
			Cell: ({ row }) => {
				return (
					<Flex justifyContent="flex-start">
						<div style={{ marginRight: "1em", height: 45, width: 45 }}>
							<CoverImage thumb rounded data={row} size={45} style={{ margin: "0 auto" }} />
						</div>

						<div>{truncateString(row.title, 30)}</div>
					</Flex>
				);
			},
		},

		{
			id: "comment",
			Header: t("commentHomeAlert", "Comment"),
			collapsing: true,
			disableSortBy: true,
		},
		{
			id: "time",
			Header: t("reminderHomeAlert", "Reminder"),
			collapsing: true,
			accessor: ({ time }) => time?.toDate?.().toLocaleString(),
		},
		{
			id: "deliveryDate",
			Header: t("deliveryDate", "Delivery date"),
			collapsing: false,
			accessor: ({ deliveryDate }) => deliveryDate?.toDate?.().toLocaleDateString(),
		},
	];
}
